<template>
  <div v-if="isLoading" class="loader-bg"></div>
</template>

<script>
import { mapGetters } from "vuex"
import Repository from "../../repositories/Repository"
import authService from "./utils/auth"
import { eventBus } from "../../main"
export default {
  name: "SSOOauth",

  computed: {
    ...mapGetters({
      user: "User/user",
    }),
  },

  created() {
    console.warn("oauth is created")
    // this.$store.commit("App/setLoading", { data: true });
    // authService.methods.getUser().then(res => {
    //   console.log(res, "user account check:::::::::::");
    //   const token = res.data.token;
    //   const circleAuth = {
    //     dtoken: token
    //   };
    //   if (!res.data.verified_account) {
    //     this.$notification.error({
    //       message: "Error",
    //       description: "User account not verified.Please check your email."
    //     });
    //   } else {
    //     this.$store
    //       .dispatch("Auth/ssoLogin", { circleAuth })
    //       .then(res => {
    //         const user = this.$store.state.user.user;
    //         Repository.defaults.headers.common[
    //           "Authorization"
    //         ] = `Bearer ${user.user.token}`;
    //         this.$router.push({ path: "/circles/all" });
    //         eventBus.$emit("refresh-circle-members-rootlogin");
    //         window.location.reload();
    //       })
    //       // eslint-disable-next-line handle-callback-err
    //       .catch(err => {
    //         // this.$store.commit('App/setLoading', { data: false })
    //         // this.$router.push({ path: '/circles/all' })
    //       });
    //   }
    // });
    // this.$store.commit("App/setLoading", { data: false });
    // // this.$router.push({ path: "/circles/all" });
    // // this.$router.go();
    // this.$router.push({ path: "/circles/all" });
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/login/oauth.vue